export default "__VITE_ASSET__f92f3dc8__"